import { FC } from 'react';
import clsx from 'clsx';
import { Box, Button } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';
import { Icon } from '@namespace/icons2';
import { TAB_VIEW_TYPES } from '../../constants';

import styles from './index.module.css';

interface PaymentFormTypeRadioProps {
  translations?: { [key: string]: unknown };
  formView: string;
  setFormView: (v: string) => void;
  disableIcons?: boolean;
  className?: string;
}

export const PaymentFormTypeRadio: FC<PaymentFormTypeRadioProps> = ({
  translations = {},
  formView,
  setFormView,
  disableIcons = false,
  className = ''
}) => {
  const { t } = useI18n();
  const {
    primaryBtnLabel = 'personalOffice.balance.sw.forms.formTypeSelector.cards',
    secondaryBtnLabel = 'personalOffice.balance.sw.forms.formTypeSelector.addCard'
  } = translations;
  const { PRIMARY, SECONDARY } = TAB_VIEW_TYPES;
  return (
    <Box className={clsx(styles.formTypeSelector, className)}>
      <Button
        className={clsx([
          styles.formTypeSelectorButton,
          styles.leftButton,
          formView === SECONDARY && styles.buttonColor
        ])}
        intent={`${formView === SECONDARY ? 'quaternary' : 'primary'}`}
        onClick={() => setFormView(PRIMARY)}
        actionType={`color${formView === PRIMARY ? '3' : '4'}`}
        size="l"
      >
        {t(primaryBtnLabel)}
      </Button>
      <Button
        className={clsx([
          styles.formTypeSelectorButton,
          styles.rightButton,
          formView === PRIMARY && styles.buttonColor
        ])}
        onClick={() => setFormView(SECONDARY)}
        intent={`${formView === PRIMARY ? 'quaternary' : 'primary'}`}
        actionType={`color${formView === PRIMARY ? '4' : '3'}`}
        size="l"
        {...(!disableIcons
          ? { iconLeft: <Icon size="m" name="icons/general/action/create" /> }
          : {})}
      >
        {t(secondaryBtnLabel)}
      </Button>
    </Box>
  );
};
